import { createContext, useContext } from "react";

export const SharedWorkerContext = createContext({
  messages: {},
  activeModal: null,
  setActiveModal() {},
  getMessageByNodeId: () => {},
  startPolling: () => {},
});

export const useSharedWorker = () => useContext(SharedWorkerContext);

export const pollingRequestStatuses = {
  inProgress: "inProgress",
  error: "InError",
  errorStatus2SMH: "Failed", // TY AB for different error statuses for the same request
  done: "Done",
};
